module.exports = __webpack_public_path__ + "static/media/tto.550e9df3.svg";